export { default as Body } from "./Body";
export { default as BodyDescription } from "./BodyDescription";

export { default as UpperBody } from "./UpperBody";
export { default as ArtistReview } from "./ArtistReview";



// WEBPACK FOOTER //
// ./src/pages/Artist/components/index.js